module.exports = __webpack_public_path__ + "img/bg-type02-pc03.9c1bcb58.png";